import { Download } from "lucide-react";

import { useDownloadReportPdf } from "../hooks/useDownloadReportPdf";

/**
 * Icon-only "Download PDF" button used on every report page's toolbar. Wraps `useDownloadReportPdf`
 * so the loading/error/double-click-guard behavior lives in exactly one place instead of being
 * copy-pasted per report type.
 *
 * @param {{
 *   reportType: "audit" | "llm_visibility" | "persona" | "ota_vs_direct" | "perception";
 *   reportId: string;
 * }} props
 */
const DownloadPdfButton = ({ reportType, reportId }) => {
  const { isDownloading, error, download } = useDownloadReportPdf(reportType, reportId);

  return (
    <div className="relative">
      <button
        onClick={download}
        disabled={isDownloading}
        title={isDownloading ? "Preparing…" : "Download Report as PDF"}
        aria-label={isDownloading ? "Preparing PDF" : "Download Report as PDF"}
        className="p-2 text-on-surface bg-surface-container-low border border-surface-container-high hover:bg-surface-container-high rounded-xl transition-colors flex items-center justify-center disabled:opacity-60 disabled:cursor-not-allowed"
      >
        <Download className={`w-4 h-4 ${isDownloading ? "animate-pulse" : ""}`} />
      </button>
      {error && (
        <p
          role="alert"
          className="absolute top-full right-0 mt-1 w-48 text-xs text-error text-right"
        >
          {error}
        </p>
      )}
    </div>
  );
};

export default DownloadPdfButton;
